<template>
  <v-col v-if="!singleComponent" cols="12">
    <!-- 
      PageTitle을 각 화면별에서
      Gnb.vue의 gnb 라인으로 옮기면서 윗 여백이 너무 떠서 그것을 조절함.
      2024.07.02.KWShin.
     -->
    <!--div class="title-area" -->
    <div class="title-area" style="margin-top: 3px">
      <div class="contents-title">
        <h2>
          <v-icon left>{{ menu.icon }}</v-icon>
          <span class="page-title" v-html="$t(menu.messageCode)" />
        </h2>
      </div>
    </div>
  </v-col>
</template>

<script>
export default {
  computed: {
    menu() {
      return this.$route.meta?.menu;
    },
    singleComponent() {
      return this.$route.meta?.singleComponent;
    },
  },
};
</script>
<style lang="scss" scoped>
.theme--light .page-title {
  color: $color-light-text;
}
.theme--dark .page-title {
  color: $color-dark-text;
}
</style>
